module.exports = __webpack_public_path__ + "static/media/discount.5d5d6943.svg";